"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tradelineType = exports.propertyLiensType = exports.lienType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var lienType = _propTypes.default.shape({
  currentBalance: _propTypes.default.number,
  interestRate: _propTypes.default.number,
  interestRateType: _propTypes.default.string,
  lastSaleDate: _propTypes.default.string,
  lender: _propTypes.default.string,
  lienPosition: _propTypes.default.number,
  lienUuid: _propTypes.default.string,
  monthlyPmt: _propTypes.default.number,
  monthsRemaining: _propTypes.default.number,
  mortgageStatusIndicator: _propTypes.default.string,
  originalBalance: _propTypes.default.number,
  originationDate: _propTypes.default.string,
  remainingTerm: _propTypes.default.number,
  term: _propTypes.default.number,
  tradelineMatchType: _propTypes.default.string,
  tradelineMatched: _propTypes.default.bool,
  lienType: _propTypes.default.string
});

exports.lienType = lienType;

var tradelineType = _propTypes.default.shape({
  currentBalance: _propTypes.default.number,
  mortgageType: _propTypes.default.string,
  originalAmount: _propTypes.default.number,
  originationDate: _propTypes.default.string,
  tradelineUuid: _propTypes.default.string
});

exports.tradelineType = tradelineType;

var propertyLiensType = _propTypes.default.shape({
  verifiedLiens: _propTypes.default.arrayOf(lienType),
  unverifiedLiens: _propTypes.default.arrayOf(lienType),
  tradelines: _propTypes.default.arrayOf(tradelineType)
});

exports.propertyLiensType = propertyLiensType;